import { useEffect } from 'react';

interface GoogleAnalyticsProps {
    trackingId?: string;
    environment?: string;
    hasConsent?: boolean;
}

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

export default function GoogleAnalytics({ trackingId, environment, hasConsent = false }: GoogleAnalyticsProps) {
    useEffect(() => {
        // Only load GA in production environment with user consent
        if (environment !== 'production' || !trackingId || !hasConsent) {
            return;
        }

        // Check if current page is a staff page
        const currentPath = window.location.pathname;
        if (currentPath.startsWith('/staff') || currentPath === '/staff') {
            return;
        }

        // Initialize dataLayer if it doesn't exist
        window.dataLayer = window.dataLayer || [];

        // Define gtag function
        window.gtag = function() {
            window.dataLayer.push(arguments);
        };

        // Load Google Analytics script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize GA
        script.onload = () => {
            window.gtag('js', new Date());
            window.gtag('config', trackingId);
        };

        return () => {
            // Cleanup script on unmount
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [trackingId, environment, hasConsent]);

    return null;
}